import React from 'react';
import classNames from 'classnames';
import { ControlLink, Stack, RadioButton } from '@moda/om';
import { PaymentMethod } from '../../../hooks/usePaymentMethods';
import { Box } from '../../Box';
import { PaymentMethodPreview } from '../PaymentMethodPreview';

import './PaymentMethodOption.scss';

type ButtonEvent = React.MouseEvent<HTMLButtonElement>;

interface Props {
  method: PaymentMethod;
  isSelected?: boolean;
  onSelect?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}

export const PaymentMethodOption: React.FC<Props> = ({
  method,
  isSelected,
  onSelect,
  onEdit,
  onDelete
}) => (
  <Box
    className={classNames('PaymentMethodOption', {
      'PaymentMethodOption--selectable': onSelect
    })}
    tabIndex={0}
    role="button"
    onKeyDown={({ key }) => key === 'Enter' && onSelect && onSelect()}
    onClick={onSelect}
  >
    <Stack space={6} direction="horizontal" alignItems="center">
      {onSelect && (
        <RadioButton data-testid="payment-radio" checked={isSelected} onChange={onSelect} />
      )}
      <div className="PaymentMethodOption__main">
        <PaymentMethodPreview method={method.attributes} />
        {(onEdit || onDelete) && (
          <Stack
            className="PaymentMethodOption__actions"
            space={4}
            direction="horizontal"
            justifyContent="flex-end"
          >
            {onDelete && (
              <ControlLink
                onClick={(event: ButtonEvent) => {
                  event.stopPropagation();
                  onDelete();
                }}
              >
                Delete
              </ControlLink>
            )}
            {onEdit && (
              <ControlLink
                onClick={(event: ButtonEvent) => {
                  event.stopPropagation();
                  onEdit();
                }}
              >
                Edit
              </ControlLink>
            )}
          </Stack>
        )}
      </div>
    </Stack>
  </Box>
);
